import React, { useContext } from 'react';
import {
    AppBar,
    Box,
    Toolbar,
    Button,
    Typography,
    useTheme,
    Popper,
    Grow,
    Paper,
    ClickAwayListener,
    MenuList,
    MenuItem,
    useMediaQuery,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import { Context } from '@/context';
import SearchBarUserLogged from '../SearchBarComponent/SearchBarUserLogged';
import NavigationButton from './NavigationButton';
import { Rutas } from '@/constants/rutas';
import NavigationItems, { NavigationItemsFixed } from './NavigationItems';
import FechasClausulables from './FechasClausulables';
import useRouterPathname from '@/DesignSystem/hooks/useRouterPathname';
import TwitchLive from '../twitch-live';
import AlineacionesProbablesIcon from '@/components/shared/icons/alineaciones-probables-icon';
import AFLogo, { LOGO_VARIANTS } from '@/DesignSystem/components/logo/AFLogo';
import { DonquiLogo } from '../icons/DonquijoteLogo';
import LottieIconComponent from '@/DesignSystem/features/lottie/LottieIconComponent';
import CustomTooltip from '@/DesignSystem/components/tooltip/CustomTooltip';
import Link from 'next/link';
import CustomLink from '../custom/custom-link';
import useIsUserPremium from '@/DesignSystem/hooks/useIsUserPremium';
import FavoritosIcon from '../icons/favoritos-icon';
import useIsUserAuthenticated from '@/DesignSystem/hooks/userIsAuthenticated';
import useFavoritos from '@/hooks/useFavoritos';
import PrediccionesFantasyIcon from '../icons/predicciones-fantasy-icon';
import useGlassStyles from '@/DesignSystem/hooks/styles/useGlassStyles';
import AIAssistantIcon from '../icons/AIAssistantIcon';
import ShareUrlModal from '../share-url-modal';

const NavigationButtons = ({ isAuthenticated, hasFavoritos, shouldDisplayPredicct = true }) => (
    <Box display="flex" alignItems="center" pr={1}>
        <ShareUrlModal />
        <NavigationButton aria-label="Navegar a analizar tu plantilla" mr={0.5} className="hidden-600">
            <CustomTooltip label="Navegar a analizar tu plantilla">
                <Link href={Rutas.ANALIZA_TU_PLANTILLA} prefetch={false} aria-label="Analizar tu plantilla">
                    <AIAssistantIcon width={35} height={35} />
                </Link>
            </CustomTooltip>
        </NavigationButton>
        {shouldDisplayPredicct && (
            <NavigationButton aria-label="Navegar a las predicciones fantasy" mr={0.5}>
                <CustomTooltip label="Navegar a las predicciones fantasy">
                    <Link
                        href={Rutas.PREDICCIONES_FANTASY}
                        prefetch={false}
                        aria-label="Predicciones fantasy"
                    >
                        <PrediccionesFantasyIcon width={25} height={25} />
                    </Link>
                </CustomTooltip>
            </NavigationButton>
        )}
        {/* <NavigationButton aria-label="Navegar a la ruleta fantasy" mr={0.5} className="hidden-1400">
            <CustomTooltip label="Navegar a la ruleta fantasy">
                <Link href={Rutas.RULETA_FANTASY} prefetch={false} aria-label="Ruleta fantasy">
                    <RuletaFantasyIcon size={25} />
                </Link>
            </CustomTooltip>
        </NavigationButton> */}
        {/* <Link href={Rutas.GUIAS_FANTASY}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 14 14">
                <g fill="none" stroke="#B0BEC5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5.5 4.054a1.5 1.5 0 1 1 1.5 1.5v.5m0 2.062a.25.25 0 0 1 0-.5m0 .5a.25.25 0 0 0 0-.5" />
                    <path d="M12.5 13.5H3a1.5 1.5 0 1 1 0-3h8.5a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H3a1.5 1.5 0 0 0-1.5 1.46v10m10-1.46v3" />
                </g>
            </svg>
        </Link> */}
        <TwitchLive />
        {/* <NavigationHaztePremium /> */}
        <NavigationButton aria-label="Navegar a la guía de fantasy" mr={0.5}>
            <DonquiLogo width={25} height={25} />
        </NavigationButton>
        {/* <NavigationButton aria-label="Navegar a la sección premium" mr={0.5}>
            <CustomTooltip label="Ir a la sección premium">
                <Link href={Rutas.PREMIUM} prefetch={false}>
                    <PremiumIcon width={25} height={25} />
                </Link>
            </CustomTooltip>
        </NavigationButton> */}
        <FechasClausulables />

        <NavigationButton aria-label="Navegar a favoritos">
            <CustomTooltip label="Favoritos">
                <Link
                    href={isAuthenticated && hasFavoritos ? Rutas.FAVORITOS_FANTASY_INFO : Rutas.FAVORITOS}
                    prefetch={false}
                    aria-label="Ir a favoritos"
                >
                    <FavoritosIcon
                        width={25}
                        height={25}
                        fillColor="transparent"
                        strokeColor="#ccc"
                        strokeWidth={1}
                    />
                </Link>
            </CustomTooltip>
        </NavigationButton>

        <NavigationButton aria-label="Navegar al buscador de jugadores">
            <CustomTooltip label="Buscar jugadores">
                <Link href={Rutas.BUSCADOR_DE_JUGADORES} prefetch={false} aria-label="Buscar jugadores">
                    <SearchIcon sx={{ width: 25, height: 25, color: '#ccc' }} />
                </Link>
            </CustomTooltip>
        </NavigationButton>
        <NavigationButton aria-label="Navegar al calendario de partidos">
            <CustomTooltip label="Alineaciones probables">
                <Link
                    href={Rutas.ALINEACIONES_PROBABLES}
                    prefetch={false}
                    aria-label="Ver alineaciones probables"
                >
                    <AlineacionesProbablesIcon
                        iconWidth={20}
                        color="#ccc"
                        style={{ transform: 'rotate(90deg)' }}
                    />
                </Link>
            </CustomTooltip>
        </NavigationButton>
        <SearchBarUserLogged />
    </Box>
);

// Componente para navegación en dispositivos móviles
const NavigationMobile = ({ handleHamburguerMenu, theme, isAuthenticated, hasFavoritos }) => {
    const height = 40;

    return (
        <>
            <Toolbar
                disableGutters
                sx={{
                    height: height,
                    minHeight: height,
                    '&.MuiToolbar-root': {
                        minHeight: height,
                    },
                    pl: 0.5,
                }}
            >
                <NavigationButton onClick={handleHamburguerMenu} aria-label="Abrir menú de navegación" mr={1}>
                    <MenuIcon sx={{ color: theme.palette.footer.text }} />
                </NavigationButton>
                <AFLogo width={25} variant={LOGO_VARIANTS.SOLO_LETRAS_VERDES} />
                <Box sx={{ flexGrow: 1 }} />
                <NavigationButtons isAuthenticated={isAuthenticated} hasFavoritos={hasFavoritos} />
            </Toolbar>
        </>
    );
};

// Menú desplegable individual para cada ítem de navegación
const NavMenuDropdown = ({ link, index, isUserPremium, className }) => {
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };

    const handleListKeyDown = (event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        } else if (event.key === 'Escape') {
            setOpen(false);
        }
    };

    return (
        <Box
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            sx={{
                position: 'relative',
                mx: 0.5,
                display: 'inline-block',
            }}
            className={className}
        >
            <Button
                ref={anchorRef}
                aria-controls={open ? `menu-list-${index}` : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                component={link.path ? Link : 'button'}
                href={link.path || undefined}
                endIcon={link.subMenu && <ArrowDropDownIcon />}
                sx={{
                    color: '#B0BEC5',
                    fontWeight: 500,
                    fontSize: 14,
                    textTransform: 'none',
                    borderBottom: open ? '2px solid white' : '2px solid transparent',
                    borderRadius: 0,
                    px: 1.5,
                    py: 1,
                    transition: 'all 0.2s',
                    '& .MuiButton-endIcon': {
                        marginLeft: 0,
                        marginRight: -4,
                    },
                    '&:hover': {
                        backgroundColor: 'rgba(255,255,255,0.1)',
                        borderBottom: '2px solid white',
                    },
                }}
            >
                {link.title}
            </Button>

            {link.subMenu && (
                <Popper
                    open={open}
                    anchorEl={anchorRef.current}
                    placement="bottom-start"
                    transition
                    sx={{ zIndex: 1300, width: 220 }}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
                            }}
                        >
                            <Paper
                                elevation={4}
                                sx={{
                                    backgroundImage:
                                        'linear-gradient(rgba(255,255,255,0.05), rgba(255,255,255,0.05))',
                                    backgroundColor: (theme) => theme.palette.footer.background,
                                }}
                            >
                                <ClickAwayListener onClickAway={handleClose}>
                                    <MenuList
                                        id={`menu-list-${index}`}
                                        aria-labelledby={`menu-button-${index}`}
                                        onKeyDown={handleListKeyDown}
                                        dense
                                    >
                                        {link.subMenu.map((subLink, subIdx) => (
                                            <CustomLink
                                                key={`sub-${index}-${subIdx}`}
                                                href={subLink.path}
                                                useNativeLink={!isUserPremium}
                                                useWrapper={true}
                                            >
                                                <MenuItem
                                                    onClick={handleClose}
                                                    sx={{
                                                        color: '#B0BEC5',
                                                        py: 1,
                                                        '&:hover': {
                                                            backgroundColor: 'rgba(255,255,255,0.1)',
                                                        },
                                                    }}
                                                >
                                                    <Typography variant="body2" fontSize={14} color="#B0BEC5">
                                                        {subLink.title}
                                                    </Typography>
                                                </MenuItem>
                                            </CustomLink>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            )}
        </Box>
    );
};

// Componente para navegación en escritorio
const NavigationDesktop = ({
    user,
    handleHamburguerMenu,
    theme,
    isUserPremium,
    isAuthenticated,
    hasFavoritos,
}) => {
    const navigationItems = NavigationItems(user, true);
    const is1250px = useMediaQuery('(min-width: 1250px)');

    return (
        <Toolbar
            disableGutters
            sx={{
                height: 50,
                minHeight: 50,
                px: 0,
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: 50,
                '&.MuiToolbar-root': {
                    minHeight: 50,
                },
                px: 2,
            }}
        >
            <NavigationButton onClick={handleHamburguerMenu} aria-label="Abrir menú de navegación">
                <MenuIcon sx={{ color: theme.palette.footer.text }} />
            </NavigationButton>
            <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', ml: 2 }}>
                {is1250px ? (
                    <AFLogo width={150} variant={LOGO_VARIANTS.TEXTO_Y_LETRAS_VERDES} />
                ) : (
                    <AFLogo width={25} variant={LOGO_VARIANTS.SOLO_LETRAS_VERDES} />
                )}
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                    height: '100%',
                    alignItems: 'center',
                    gap: 2,
                    justifyContent: 'center',
                }}
            >
                {navigationItems.map((link, index) => (
                    <NavMenuDropdown
                        key={index}
                        link={link}
                        index={index}
                        isUserPremium={isUserPremium}
                        className={link.className}
                    />
                ))}
            </Box>

            <NavigationButtons isAuthenticated={isAuthenticated} hasFavoritos={hasFavoritos} />
        </Toolbar>
    );
};

// Componente principal de navegación
const Navigation = ({ handleHamburguerMenu }) => {
    const theme = useTheme();
    const { state } = useContext(Context);
    const isDesktop = useMediaQuery('(min-width: 1100px)');
    const isUserPremium = useIsUserPremium();
    const isAuthenticated = useIsUserAuthenticated();
    const { hasFavoritos } = useFavoritos();

    const glassStyles = useGlassStyles(theme);

    const navigationsFixedMobile = NavigationItemsFixed();
    const pathname = useRouterPathname();

    return (
        <>
            <AppBar
                position="sticky"
                sx={{
                    top: 0,
                    height: 40,
                    minHeight: 40,
                    zIndex: (t) => t.zIndex.appBar, // 1200 está bien, pero así usa el del tema
                    boxShadow: 'none',
                    // Fallback sólido si no hay soporte de backdrop-filter
                    backgroundColor: theme.palette.background?.default,
                    // Sobrescribir con glass cuando hay soporte:
                    '@supports (backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))': {
                        ...glassStyles,
                    },
                }}
            >
                {isDesktop ? (
                    <NavigationDesktop
                        user={state.user}
                        handleHamburguerMenu={handleHamburguerMenu}
                        theme={theme}
                        isUserPremium={isUserPremium}
                        isAuthenticated={isAuthenticated}
                        hasFavoritos={hasFavoritos}
                    />
                ) : (
                    <NavigationMobile
                        handleHamburguerMenu={handleHamburguerMenu}
                        user={state.user}
                        theme={theme}
                        isUserPremium={isUserPremium}
                        isAuthenticated={isAuthenticated}
                        hasFavoritos={hasFavoritos}
                    />
                )}
            </AppBar>

            {!isDesktop && (
                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        p: 1,
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        backgroundColor: 'background.default',
                        justifyContent: 'space-around',
                        zIndex: 1300,
                        width: '100vw',
                        height: '60px',
                        borderTop: '1px solid',
                        borderColor: 'border.main',
                    }}
                >
                    {navigationsFixedMobile.map((link, index) => {
                        const isSelected = link.path === pathname;
                        const color = isSelected ? 'primary.main' : 'text.primary';
                        return (
                            <CustomLink
                                key={index}
                                href={link.path}
                                sx={{
                                    color,
                                    fontSize: 14,
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                linkStyles={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                useNativeLink={!isUserPremium}
                            >
                                {link.lottieIcon ? (
                                    <LottieIconComponent icon={link.lottieIcon} width={50} height={50} />
                                ) : (
                                    link.icon
                                )}
                                {link.shortTitle && !link.hideShortTitle && (
                                    <Typography variant="body2" fontSize={14} color={color}>
                                        {link.shortTitle}
                                    </Typography>
                                )}
                            </CustomLink>
                        );
                    })}
                </Box>
            )}
        </>
    );
};

export default Navigation;
